import { render, staticRenderFns } from "./PaymentMethodCreate.vue?vue&type=template&id=ced0a248"
import script from "../../controllers/payment_method/payment-method-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_method/payment-method-create.js?vue&type=script&lang=js&external"
import style0 from "./PaymentMethodCreate.vue?vue&type=style&index=0&id=ced0a248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports